__turbopack_context__.v({
  "Caption": "index-module__qZKqgG__Caption",
  "Checkbox": "index-module__qZKqgG__Checkbox",
  "CheckboxGroup": "index-module__qZKqgG__CheckboxGroup",
  "Indicator": "index-module__qZKqgG__Indicator",
  "Item": "index-module__qZKqgG__Item",
});
